<div *ngIf="showProgress">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-form-field class="column-form-field" *ngFor="let column of columns">
  <mat-label>{{getFullColumnName(column.code)}}</mat-label>
  <input matInput type="text" [(ngModel)]="column.name" (ngModelChange)="valueChanged()">
</mat-form-field>
